module.exports = {
          srcSet: __webpack_public_path__ + "671cc98117ef1095b9e78cb838de8c8f-1279.png"+" 1279w",
          images:[ {path: __webpack_public_path__ + "671cc98117ef1095b9e78cb838de8c8f-1279.png",width: 1279,height: 538}],
          src: __webpack_public_path__ + "671cc98117ef1095b9e78cb838de8c8f-1279.png",
          toString:function(){return __webpack_public_path__ + "671cc98117ef1095b9e78cb838de8c8f-1279.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAc0lEQVR4nC2NMQ7CQAwETXKiQ0KhpOYpeRw9TRqeRpcKgigDd55FiyhGI8sjO4CNpGKAcuPtubu25Xipy0FSPKldSOoleRl3WnwgEk5z1umR7SxpmPIVDre+4LBCrOB4vyYjMAp2SMWh39q/0LS/Mdns/gtQGneK+HEenAAAAABJRU5ErkJggg==",
          width: 1279,
          height: 538
        }